import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { IconComponent, TooltipDirective } from '@mode/capra';
import { AxisComponent } from './axis/axis.component';
import { FormatBuilderComponent } from './format-builder.component';
import { HeaderComponent } from './header/header.component';
import { LegendComponent } from './legend/legend.component';
import { PaneComponent } from './pane/pane.component';

import { DatePickerComponent } from '@mode/shared/ui';
import { DropdownListComponent } from './dropdown/dropdown-list.component';
import { FieldSelectorComponent } from './field-selector/field-selector.component';
import { FormatShortcutMenuComponent } from './format-shortcut-menu/format-shortcut-menu.component';
import { LabelOrCustomPipe } from './format-shortcut-menu/label-or-custom.pipe';
import { RangeComponent } from './range/range.component';
import { RotationComponent } from './rotation/rotation.component';
import { ScaleComponent } from './scale/scale.component';
import { BinnedAxisLabelsComponent } from './binned-axis-labels/binned-axis-labels.component';
import { TitleComponent } from './title/title.component';
import { ValuesComponent } from './values/values.component';
import { DisplayLabelComponent } from './display-label/display-label.component';

@NgModule({
  imports: [
    CommonModule,
    DatePickerComponent,
    IconComponent,
    MatExpansionModule,
    MatLegacyMenuModule,
    ReactiveFormsModule,
    TooltipDirective,
  ],
  declarations: [
    FormatBuilderComponent,
    AxisComponent,
    HeaderComponent,
    LegendComponent,
    PaneComponent,
    TitleComponent,
    FieldSelectorComponent,
    FormatShortcutMenuComponent,
    LabelOrCustomPipe,
    RangeComponent,
    ValuesComponent,
    RotationComponent,
    ScaleComponent,
    BinnedAxisLabelsComponent,
    DropdownListComponent,
    DisplayLabelComponent,
  ],
  exports: [FormatBuilderComponent, DropdownListComponent],
})
export class ChartsFormatBuilderModule {}
